import Button from "@/Components/Button/Button";
import ButtonGroup from "@/Components/ButtonGroup/ButtonGroup";
import { ButtonGroupOption } from "@/Components/ButtonGroup/types";
import { useSetLiveModal } from "@/shared/atoms/useLiveModal";
import { useSetModal } from "@/shared/atoms/useModal";
import useCommon from "@/shared/hooks/useCommon";
import useElectronHook from "@/shared/hooks/useElectronHook";
import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import useRoleHooks from "@/shared/hooks/useRoleHooks";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { modalNameEnum } from ".";
import ElectronReload from "./ElectronReload";
import LiveMobilePosButton from "./LiveMobilePosButton";
import LivePrinterButton from "./LivePrinterButton";
import LiveSound from "./LiveSound";

const Mobile = () => {
  const history = useHistory();
  const t = useCommon();
  const setModal = useSetModal();
  const setModalName = useSetLiveModal();
  const { isElectron } = useElectronHook();
  const { isAppsmenEmployee } = useRoleHooks();
  const customFilters = useMemo<ButtonGroupOption[]>(
    () => [
      {
        group: false,
        id: 1,
        label: t("orders_live.orderTrackerSettings"),
        onClick: () => {
          setModal("systemTracker");
        },
      },
      {
        group: false,
        id: 2,
        label: t("orders_live.orderMap"),
        onClick: () => {
          setModalName(modalNameEnum.ORDER_MAP);
        },
      },
      {
        disabled: !isAppsmenEmployee || !isElectron,
        group: true,
        id: 3,
        label: t("orders_live.printerSettings"),
        onClick: () => {
          setModalName(modalNameEnum.PRINTER_SETTINGS_MODAL);
        },
      },
      {
        group: true,
        id: 4,
        label: t("manageMoney"),
        onClick: () => {
          setModal("deposit");
        },
      },
      {
        group: true,
        id: 5,
        label: t("qrOrders"),
        onClick: () => {
          history.push("/screen/table");
        },
      },
    ],
    [t, isElectron, isAppsmenEmployee]
  );
  return (
    <div className="flex items-center gap-2">
      <ButtonGroup options={customFilters} />
      <ElectronReload />
      <LiveSound />
      <LiveMobilePosButton />
    </div>
  );
};

const Desktop = () => {
  const t = useCommon();
  const setModal = useSetModal();
  const setModalName = useSetLiveModal();
  return (
    <div
      data-tour="live-orders.actions"
      className="mr-auto flex flex-row flex-wrap items-center gap-4 md:gap-0"
    >
      <div
        onClick={() => setModal("systemTracker")}
        className="mr-8 font-semibold"
      >
        <Button size="small">{t("orders_live.orderTrackerSettings")}</Button>
      </div>
      <LivePrinterButton />
      <div
        onClick={() => setModalName(modalNameEnum.ORDER_MAP)}
        className="mr-8 font-semibold"
      >
        <Button size="small">{t("orders_live.orderMap")}</Button>
      </div>
      <div onClick={() => setModal("deposit")} className="mr-8 font-semibold">
        <Button size="small">{t("manageMoney")}</Button>
      </div>
      <ElectronReload />
    </div>
  );
};

const LiveButtons = () => {
  const isMobile = useIsMobileHook();

  return isMobile ? <Mobile /> : <Desktop />;
};

export default LiveButtons;
